import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const BottomGradient = ({
    color,
    height = '128px',
    width = '100%',
    opacity = 1,
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    color = color || theme.palette.figma.bottomColor;

    const gradientStyles = {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: height,
        width: width,
        background: `linear-gradient(to bottom, transparent 0%, ${color} 100%)`,
        opacity: opacity,
        pointerEvents: 'none',
        zIndex: 1, // Above card backgrounds, below content
        ...sx,
    };

    return <Box sx={gradientStyles} {...props} />;
};

export default BottomGradient;
